import {PropsWithChildren} from 'react';
import {DayOfWeekLayoutCategory} from './DayOfWeekLayoutCategory';
import {DayOfWeekLayoutColumn} from './DayOfWeekLayoutColumn';
import {DayOfWeekLayoutDayTab} from './DayOfWeekLayoutDayTab';
import {DayOfWeekLayoutMenuListAndSortTab} from './DayOfWeekLayoutMenuListAndSortTab';

export const DayOfWeekLayout = ({children}: PropsWithChildren) => {
  return <>{children}</>;
};

DayOfWeekLayout.DayTab = DayOfWeekLayoutDayTab;
DayOfWeekLayout.MenuListAndSortTab = DayOfWeekLayoutMenuListAndSortTab;
DayOfWeekLayout.Column = DayOfWeekLayoutColumn;
DayOfWeekLayout.Category = DayOfWeekLayoutCategory;
